import { useSentryHooks } from '$lib/sentry/sentry_hooks_config.js'

// Sentry use in FrontEnd conditional to Environment
// !!! COMMENT condition for test in local and RUN => npm run build:run
if (useSentryHooks()) {
	await import('$lib/sentry/sentry_hooks.client.ts')
}
